module.exports = __webpack_public_path__ + "img/icon_order_gray.41618aac.svg";